import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import UserList from "./UserList";
import { LangContext } from "../LangContext.jsx";

class TopUsersPanel extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            users: [],
            total: 0,
        };
    }

    componentDidMount() {
        this.getUsers()
    }

    async getUsers(){
        var url = `/api/users`;
        const res = await axios.get(url);
        const data = res.data.slice(0, this.props.top);
        this.setState({users: data});
        this.setState({total: res.data.length});
    }

    getInitials(name){
        const nameList = name.split(' ')
        return nameList.length >= 2 ? `${nameList[0][0]}${nameList[1][0]}` : nameList[0][0]
    }

    render() {
        const { lang } = this.context; 
        const userTypeLabel = (user) => Number(user.is_developer) === 1 ? 'Developer' : lang.get('messages.' + user.roleTitle.toLowerCase());

        return (
            <div className="card card-custom gutter-b my-5">
                <div className="card-header border-0 pt-6">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label font-weight-bolder font-size-h4 text-dark-75">{lang.get('messages.usuarios')}</span>
                        <span className="text-muted mt-3 font-weight-bold font-size-lg">{this.state.total} {lang.get('messages.usuarios_registrados')}</span>
                    </h3>
                    { this.props.top != null &&
                        <div className="card-toolbar">
                            <ul className="nav nav-pills nav-pills-sm nav-dark">
                                <li className="nav-item ml-0">
                                    <a href="/users" className="btn btn-icon-primary btn-clean btn-hover-light-primary btn-sm btn-icon">
                                        <span className="svg-icon svg-icon-lg">
                                            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                <g stroke="none" strokeWidth="1">
                                                    <rect x="14" y="9" width="6" height="6" rx="3" fill="black" />
                                                    <rect x="3" y="9" width="6" height="6" rx="3" fill="black" fillOpacity="0.7" />
                                                </g>
                                            </svg>
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    }
                </div>
                <div className="card-body pt-5">
                    { this.state.users.map((user, i) => {
                        return <div key={i}>
                            <div className="d-flex align-items-center py-2">
                                <div className="symbol symbol-40">
                                    <div className="symbol-label bg-primary-o-40 text-primary font-weight-bolder">
                                        {this.getInitials(user.name)}
                                    </div>
                                </div>
                                <div className="d-flex flex-column flex-grow-1 my-lg-0 m-2">
                                {user.role_id != 1 &&
                                <>
                                <a href={"/users/" + user.userId + "/edit"} className={"text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"}>
                                        {user.name}
                                    </a>
                                </>
                                }
                                {user.role_id == 1 &&
                                <>
                                    {user.name}
                                </>
                                }
                                <span className="font-size-xs text-muted">{userTypeLabel(user)}  </span>
                                </div>
                                {user.role_id != 1 &&
                                <>
                                    <a href={"/users/" + user.userId + "/edit"}>
                                        <button className="btn btn-icon btn-light btn-xs">
                                            <i className={"flaticon2-right-arrow icon-sm text-primary"}></i>
                                        </button>
                                    </a>
                                </>
                                }
                            </div>
                        </div>
                    })}
                </div>
            </div>
        );
    }
}

export default TopUsersPanel;

if (document.getElementById('TopUsersPanel')) {
    ReactDOM.render(<TopUsersPanel />, document.getElementById('TopUsersPanel'));
}
